<template>
  <form
    class="form"
    method="POST"
    action="javascript:;"
    @submit.prevent="submit"
  >
    <FormError v-if="formError.length > 0" :errorMessages="formError" />

    <FormLoading v-if="!formReady" />

    <CardBase v-else>
      <template #header>{{ $route.meta.title }}</template>
      <template #content>
        <FormNote class="mb-6"
          >Note: Data di bawah ini akan dipindahkan ke member tujuan.</FormNote
        >

        <FormRow class="mb-4" v-if="formData.member_account.length > 0">
          <template #label>Account ID</template>
          <template #field>
            <ul class="list-inside md:mt-2">
              <li
                class="text-sm"
                v-for="account in formData.member_account"
                :key="account.uuid"
              >
                {{ account.tooltip }}
              </li>
            </ul>
          </template>
        </FormRow>

        <FormRow class="mb-4" v-if="formData.member_bank_account.length > 0">
          <template #label>Bank Account</template>
          <template #field>
            <ul class="list-inside md:mt-2">
              <li
                class="text-sm"
                v-for="bank in formData.member_bank_account"
                :key="bank.uuid"
              >
                {{ bank.tooltip }}
              </li>
            </ul>
          </template>
        </FormRow>

        <FormRow class="mb-4" :required="true">
          <template #label>UUID Member Tujuan</template>
          <template #field>
            <input
              type="text"
              class="form__input"
              placeholder="UUID Member Tujuan"
              v-model="formData.to_member_uuid"
            />
            <div
              class="form-error"
              v-if="$v.formData.to_member_uuid.$error && formSubmitted"
            >
              <span
                class="form-error__text"
                v-if="!$v.formData.to_member_uuid.required"
                >This field is required.</span
              >
            </div>
          </template>
          <template #help>Masukkan UUID member tujuan.</template>
        </FormRow>

        <FormRow class="mb-4" :required="true">
          <template #label>Reason for Update</template>
          <template #field>
            <textarea
              class="form__input"
              placeholder="Reason for Update"
              rows="5"
              v-model="formData.reason"
            ></textarea>
            <div
              class="form-error"
              v-if="$v.formData.reason.$error"
            >
              <span class="form-error__text" v-if="!$v.formData.reason.required"
                >This field is required.</span
              >
            </div>
          </template>
        </FormRow>
      </template>

      <template #footer>
        <FormRow class="mb-0">
          <template #field>
            <BaseButton type="submit">Submit</BaseButton>
          </template>
          <template #link>
            <div class="ml-4 poppins">
              or
              <router-link :to="{ name: 'MemberList' }" class="link ml-2"
                >Back to List Members</router-link
              >
            </div>
          </template>
        </FormRow>
      </template>
    </CardBase>
  </form>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<script>
import { required } from "vuelidate/lib/validators";
import { submitFormMixin } from "@/mixins/submitFormMixin";

export default {
  mixins: [submitFormMixin],
  components: {
  },
  validations() {
    return {
      formData: {
        to_member_uuid: {
          required,
        },
        reason: {
          required
        }
      },
    };
  },
  created() {
    this.$_debounceTimer = null;
  },
  data: () => {
    return {


      formData: {
        from: null,
        to: null,
      },
    };
  },
  computed: {
    submitUrl() {
      return this.formCreate
        ? "/" + this.$route.meta.endpoint(this.$route)
        : "/" +
            this.$route.meta.endpoint(this.$route) +
            "/" +
            this.formData.uuid;
    },
    fetchEndPoint() {
      return this.$route.meta.endpoint(this.$route);
    },
  },
  methods: {
    fetchData(id) {
      this.formReady = false;

      const itemId = id ? id : this.formData.id;

      this.$http
        .get(
          process.env.VUE_APP_API_URL + "/" + this.fetchEndPoint + "/" + itemId + "/transfer"
        )
        .then((res) => {
          if (res.status == 200) {
            const { data } = res.data;
            this.formData = { ...this.formData, ...data };
            this.formReady = true;
          }
        })
        .catch((err) => {
          if (err.response.status == 404) {
            this.$router.push({ name: this.$route.meta.baseRoute });
          } else if (err.response.status == 500) {
            this.formError = [];
            this.formError[0] = err.response.data.message;
          }
        })
        .finally(() => {});
    },
    debounce(method, timer) {
      if (this.$_debounceTimer !== null) {
        clearTimeout(this.$_debounceTimer);
      }
      this.$_debounceTimer = setTimeout(() => {
        method();
      }, timer);
    },
    submit() {
      if (!this.formLoading) {
        this.formSubmitted = true;
        this.$v.$touch();

        if (this.$v.$invalid) {
          return;
        }

        this.formLoading = true;
        this.$store.commit("toggleLoading");

        this.$http({
          method: "patch",
          url: process.env.VUE_APP_API_URL + "/" + this.fetchEndPoint + "/" + this.formData.id + "/transfer",
          data: this.formData,
        })
          .then((res) => {
            if (res.status == 200 || res.status == 201) {
              this.$router.push({ name: this.$route.meta.baseRoute }, () => {
                this.$swal({
                  position: "bottom-end",
                  showConfirmButton: false,
                  toast: true,
                  timer: 5000,
                  timerProgressBar: true,
                  title: res.data.message,
                  icon: "success",
                });
              });
            }
          })
          .catch((error) => {
            if (error.response) {
              this.formError = [];

              if (error.response.status == 404) {
                // this.formError[0] = '<pre>' + error.response.data.meta + '</pre>';
              } else if (error.response.status == 409) {
                // this.formError[0] = error.response.data;
              } else {
                const { data } = error.response.data;
                for (var err in data) {
                  this.formError.push(data[err]);
                }
              }
            }
          })
          .finally(() => {
            this.$store.commit("toggleLoading");
            this.formLoading = false;
            this.formSubmitted = false;
          });
      }
    },
  },
};
</script>
